import { lazy } from 'react'

export const AdminPanel = lazy(() => import('./dashboard/adminPanel'))
export const BrandsManagementPage = lazy(
  () => import('./dashboard/brandsManagementPage')
)
export const AiContextManagement = lazy(
  () => import('./dashboard/aiContextManagement')
)
export const AiLimitsManagement = lazy(
  () => import('./dashboard/aiLimitsManagement')
)
export const Analytics = lazy(() => import('./dashboard/analytics'))
export const AssetsPage = lazy(() => import('./dashboard/assets'))
export const AssetsAddPage = lazy(() => import('./dashboard/assetsAddPage'))
export const AssetsEditPage = lazy(() => import('./dashboard/assetsEditPage'))
export const AssetsSearchPage = lazy(() => import('./dashboard/assetsSearch'))
export const BrandContextAddPage = lazy(
  () => import('./dashboard/brandContextAddPage')
)
export const BrandContextEditPage = lazy(
  () => import('./dashboard/brandContextEditPage')
)
export const ExtendedContextAddPage = lazy(
  () => import('./dashboard/extendedContextAddPage')
)
export const ExtendedContextEditPage = lazy(
  () => import('./dashboard/extendedContextEditPage')
)
export const ImageEditorPage = lazy(() => import('./dashboard/imageEditor'))
export const LandingPagesPage = lazy(() => import('./dashboard/landingPages'))
export const LandingPagesAdminPage = lazy(
  () => import('./dashboard/landingPagesAdminPage')
)
export const LandingPageFontsAdminPage = lazy(
  () => import('./dashboard/landingPageFontsAdminPage')
)
export const LandingPagesAssetsPage = lazy(
  () => import('./dashboard/landingPagesAssets')
)
export const LandingPageAddPage = lazy(
  () => import('./dashboard/landingPageAddPage')
)
export const LandingPageEditPage = lazy(
  () => import('./dashboard/landingPageEditPage')
)
export const LandingPageAssetAddPage = lazy(
  () => import('./dashboard/landingPageAssetAddPage')
)
export const LandingPageAssetEditPage = lazy(
  () => import('./dashboard/landingPageAssetEditPage')
)
export const LandingPagePreviewPage = lazy(
  () => import('./landingPagePreview/landingPagePreview')
)
export const PackagesPage = lazy(() => import('./dashboard/packages'))
export const ProductAddPage = lazy(() => import('./dashboard/productAddPage'))
export const ProductEditPage = lazy(() => import('./dashboard/productEditPage'))
export const ProductsPage = lazy(() => import('./dashboard/products'))
export const UserCreate = lazy(() => import('./dashboard/userCreate'))
export const UserEdit = lazy(() => import('./dashboard/userEdit'))
export const UserList = lazy(() => import('./dashboard/userList'))
export const CardPreviewPage = lazy(() => import('./cardPreview/cardPreview'))
export const ChristmasCardPage = lazy(
  () => import('./christmasCard/christmasCard')
)
export const IFramePreviewPage = lazy(() => import('./package/iframePreview'))
export const PackageDetails = lazy(() => import('./package/packageDetails'))
export const ReviewAccessPage = lazy(
  () => import('./reviewAccess/ReviewAccessPage')
)
export const ReviewsPage = lazy(() => import('./dashboard/reviews'))
export const ReviewSessionDetailPage = lazy(
  () => import('./dashboard/reviewSessionDetail')
)
export const ReviewSessionRoomPage = lazy(
  () => import('./dashboard/reviewSessionRoom')
)
